import type { RouteObject } from 'react-router-dom';
import PublicLayout from '../components/layout/PublicLayout';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from './ProtectedRoute';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import ProductsPage from '../pages/products/page';
import ProductDetailPage from '../pages/product-detail/page';
import PricingPage from '../pages/pricing/page';
import CheckoutPage from '../pages/checkout/page';
import LoginPage from '../pages/login/page';
import RegisterPage from '../pages/register/page';
import DashboardOverview from '../pages/dashboard/page';
import DashboardOrders from '../pages/dashboard/orders/page';
import DashboardLicenses from '../pages/dashboard/licenses/page';
import LicenseDetailPage from '../pages/dashboard/license-detail/page';
import DashboardDownloads from '../pages/dashboard/downloads/page';
import DashboardProfile from '../pages/dashboard/profile/page';
import AdminOverview from '../pages/admin/page';
import AdminProducts from '../pages/admin/products/page';
import AdminProductForm from '../pages/admin/product-form/page';
import AdminCategories from '../pages/admin/categories/page';
import AdminTypes from '../pages/admin/types/page';
import AdminMedia from '../pages/admin/media/page';
import AdminOrders from '../pages/admin/orders/page';
import AdminOrderNew from '../pages/admin/orders/new/page';
import AdminLicenses from '../pages/admin/licenses/page';
import AdminLicenseGenerate from '../pages/admin/license-generate/page';
import AdminCustomers from '../pages/admin/customers/page';
import AdminActivations from '../pages/admin/activations/page';
import AdminDownloads from '../pages/admin/downloads/page';
import AdminPlans from '../pages/admin/plans/page';
import AdminSettings from '../pages/admin/settings/page';
import AdminWebhooks from '../pages/admin/webhooks/page';
import AdminReviews from '../pages/admin/reviews/page';
import AdminSupport from '../pages/admin/support/page';
import AdminActivity from '../pages/admin/activity/page';
import DocsPage from '../pages/docs/page';
import DocsIndexPage from '../pages/docs/index';
import ConnectPage from '../pages/connect/page';

const routes: RouteObject[] = [
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/products', element: <ProductsPage /> },
      { path: '/product/:slug', element: <ProductDetailPage /> },
      { path: '/docs', element: <DocsIndexPage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/checkout', element: <CheckoutPage /> },
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
    ],
  },
  {
    element: <ProtectedRoute allowedRole="customer" />,
    children: [
      {
        element: <DashboardLayout mode="customer" />,
        children: [
          { path: '/dashboard', element: <DashboardOverview /> },
          { path: '/dashboard/orders', element: <DashboardOrders /> },
          { path: '/dashboard/licenses', element: <DashboardLicenses /> },
          { path: '/dashboard/licenses/:id', element: <LicenseDetailPage /> },
          { path: '/dashboard/downloads', element: <DashboardDownloads /> },
          { path: '/dashboard/profile', element: <DashboardProfile /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRole="admin" />,
    children: [
      {
        element: <DashboardLayout mode="admin" />,
        children: [
          { path: '/admin', element: <AdminOverview /> },
          { path: '/admin/products', element: <AdminProducts /> },
          { path: '/admin/products/new', element: <AdminProductForm /> },
          { path: '/admin/products/:id/edit', element: <AdminProductForm /> },
          { path: '/admin/categories', element: <AdminCategories /> },
          { path: '/admin/types', element: <AdminTypes /> },
          { path: '/admin/plans', element: <AdminPlans /> },
          { path: '/admin/media', element: <AdminMedia /> },
          { path: '/admin/orders', element: <AdminOrders /> },
          { path: '/admin/orders/new', element: <AdminOrderNew /> },
          { path: '/admin/licenses', element: <AdminLicenses /> },
          {
            path: '/admin/licenses/generate',
            element: <AdminLicenseGenerate />,
          },
          { path: '/admin/customers', element: <AdminCustomers /> },
          { path: '/admin/activations', element: <AdminActivations /> },
          { path: '/admin/downloads', element: <AdminDownloads /> },
          { path: '/admin/reviews', element: <AdminReviews /> },
          { path: '/admin/profile', element: <DashboardProfile /> },
          { path: '/admin/settings', element: <AdminSettings /> },
          { path: '/admin/support', element: <AdminSupport /> },
          { path: '/admin/activity', element: <AdminActivity /> },
          { path: '/admin/webhooks', element: <AdminWebhooks /> },
        ],
      },
    ],
  },
  {
    path: '/docs/:slug',
    element: <DocsPage />,
  },
  {
    path: '/connect',
    element: <ConnectPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
